"use strict";

angular.module('tao_configuration',[])
    .constant('tao_host', 'http://taoplatform.exploros.com')
    .constant('tao_host_failover', 'http://taoplatform.exploros.com')
    .constant('tao_retry_delay', 1000)
    .constant('tao_attempts', 3)
    .constant('tao_api', 'http://taoplatform.exploros.com:8008')
    .constant('tao_api_failover', 'http://taoplatform.exploros.com:8008');